import script from "./Drama.vue?vue&type=script&setup=true&lang=js"
export * from "./Drama.vue?vue&type=script&setup=true&lang=js"

import "./Drama.vue?vue&type=style&index=0&id=9b4d393e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_mcn_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b4d393e"]])

export default __exports__